<div *ngIf="showOverlay" 
     [class]="getOverlayClasses()" 
     [attr.data-height-category]="heightCategory"
     style="top: 0; left: 0; right: 0;"
     [style.height]="height">
  <div [class]="containerClass">
    <div class="mb-4">
      <i [class]="icon + ' no-records-icon'" 
         [style.color]="iconColor"></i>
    </div>
    <h5 class="text-dark mb-2 font-weight-bold">
      {{message}}
    </h5>
    <p class="text-muted mb-0">{{subMessage}}</p>
  </div>
</div>
